
import { Alert } from "antd";

export default function AlertDismissError(props) {
    return (
        <>
            <Alert message="Error" description={props.message} type="error" showIcon closable />
        </>
    );
}